import { DSL } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { gatewayEndpointType } from 'root/src/shared/descriptions/endpoints/lenses'
import { authenticationTypes } from 'root/src/shared/constants/auth'

export default {
	[DSL]: {
		authentication: authenticationTypes.optional,
		endpointType: gatewayEndpointType,
		payloadSchema: {
			type: 'object',
			properties: {
				channelId: { type: 'string' },
			},
			additionalProperties: false,
		},
	},
}
